// The 12 psychological dimensions this assessment maps. `name` is the
// clinical dimension name — matches backend/app/dimensions.py exactly, so
// colors/labels stay in sync between the marketing site and the actual
// report the customer receives.
export const DIMENSIONS = [
  {
    id: 1, name: "Cognitive Function",
    color: "#E0115F",
    label: "Passion",
    insight: "You call it burnout. It's a fire your subconscious wasn't allowed to burn.",
  },
  {
    id: 2, name: "Mental & Emotional Health",
    color: "#9966CC",
    label: "Intuition",
    insight: "The whisper you keep dismissing is the one you were built to follow.",
  },
  {
    id: 3, name: "Mood Patterns",
    color: "#50C878",
    label: "Balance",
    insight: "Your restlessness isn't a flaw — it's an unclaimed axis.",
  },
  {
    id: 4, name: "Personality Structure",
    color: "#0F52BA",
    label: "Wisdom",
    insight: "You already know. You've been trained to distrust that knowing.",
  },
  {
    id: 5, name: "Relationship Functioning",
    color: "#FFC87C",
    label: "Clarity",
    insight: "You think it's indecision. It's a mind trying to protect old fear.",
  },
  {
    id: 6, name: "Childhood Patterns",
    color: "#F7CAC9",
    label: "Compassion",
    insight: "Your softness was labelled weakness by people who couldn't hold it.",
  },
  {
    id: 7, name: "Motivation Style",
    color: "#40E0D0",
    label: "Expression",
    insight: "The words you swallow become the anxieties you carry.",
  },
  {
    id: 8, name: "Lifestyle & Physical",
    color: "#E34234",
    label: "Vitality",
    insight: "You're not tired. You're leaking energy into old loops.",
  },
  {
    id: 9, name: "Beliefs & Moral Values",
    color: "#26619C",
    label: "Insight",
    insight: "The pattern you keep meeting isn't a person. It's a mirror.",
  },
  {
    id: 10, name: "Family & Support System",
    color: "#00A86B",
    label: "Harmony",
    insight: "You're not conflicted. Two parts of you are protecting different truths.",
  },
  {
    id: 11, name: "Coping & Learning Mindset",
    color: "#F4F6F0",
    label: "Peace",
    insight: "Rest scares you because stillness is where the buried voices speak.",
  },
  {
    id: 12, name: "Life Narrative",
    color: "#E4D00A",
    label: "Joy",
    insight: "You think it's laziness. It's a subconscious safety pattern.",
  },
];
